import {Component, Inject, OnInit} from '@angular/core';
import {UserModel} from '../../../models/user.model';
import {MenuModel, MenuService} from '../../../../provider/menu.service';
import {UserService} from '../../../../provider/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PermissionsService} from '../../../../provider/permissions.service';
import {MenuAsideService} from '../../../../core/_base/layout';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'kt-user-edit',
  templateUrl: './user-edit.popup.html',
  styleUrls: ['./user-edit.popup.scss']
})
export class UserEditPopup implements OnInit {

  user: UserModel;
  datas: MenuModel[] = [];
  hotels = [];
  app_hotels = [];
  role = '';
  id = '';
  title = 'Add User';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public menuService: MenuService,
              public userService: UserService,
              private route: ActivatedRoute,
              private permissionsService: PermissionsService,
              private menuAsideService: MenuAsideService,
              private router: Router) {
    this.menuAsideService.pathname$.next(window.location.pathname);

    this.datas = this.menuService.menu_change$.getValue();
    this.menuService.getMenu();
    this.userService.getDepartment();

    this.id = this.data.data.id;
    this.userService.getMe();

    if (this.userService.record_change$.getValue() == undefined) {
      this.router.navigateByUrl('/users');
      return;
    }

    this.hotels = this.userService.record_change$.getValue().hotel_names.split(',');
    this.role = this.userService.record_change$.getValue().role;
    this.hotels.forEach(x => x.split('|'));

    if (this.id != '0') {
      this.title = 'Edit User';
      // this.userService.getUser(this.id).subscribe(
      //   (resp: UserModel) => {
      //     this.user = resp;
      //     console.log(this.user);
      //     this.user.app_hotels.split(',').forEach(x => {
      //       this.app_hotels.push(x);
      //     });
      //
      //     if (this.user.role == 'user') {
      //       this.permissionsService.getPermissionSetByID(+this.id).subscribe(
      //         (data: PermissionSetsModel[]) => {
      //           this.userPermissions = data;
      //           if (this.userPermissions.length != 0) {
      //             this.datas.forEach(x => {
      //               x.sections.forEach(y => {
      //                 y.show = this.userPermissions.find(z => +z.menu_section_id == y.id).show;
      //               });
      //             });
      //           }
      //         }
      //       );
      //     }
      //   }
      // );
    } else {
      this.app_hotels.push(this.userService.record_change$.getValue().app_hotel_id);
    }
  }

  ngOnInit() {
    this.user = this.data.data;

  }

  Update() {
    this.userService.postUser(this.user);
    this.router.navigateByUrl('/users').then();
  }

  getHotelName(hotel: string) {
    return hotel.split('|')[1];
  }

  getHotelId(hotel: any) {
    return hotel.split('|')[0];
  }

  IsTitle(i: number) {
    return this.datas[i].sections.find(x => x.show == true);
  }

  departmentChange(event) {
    this.user.department_id = +event.target.value;
    this.user.department_name = this.userService.department_change$.getValue().find(x => x.id == +event.target.value).name;
    console.log(this.user)
  }
}
